import React from 'react';
import { LinkContainer, LinkText, LinkInput, Copied } from './StyledComponents';

export default function Link({ projectId, copied, setCopied }) {
  const url = `https://elastic-villani-a0d506.netlify.com/?id=${projectId}`
  const copy = () => {
    var copyText = document.getElementById('share-link');
    copyText.select();
    document.execCommand('copy', false);
    setCopied();
  };
  const storeCopy = event => {
    event.preventDefault();
    if (event.clipboardData) {
      event.clipboardData.setData(
        'text/plain',
        url
      );
    }
  };
  const useAsyncClipboardAPI = () => {
    window.navigator.clipboard.writeText(url)
      .then(() => {
        console.log('Text copied to clipboard');
      })
      .catch(err => {
        // This can happen if the user denies clipboard permissions:
        console.error('Could not copy text: ', err);
      });
  }
  // if we load this - lets copy it to the clipbord automatically - wont work on all browsers
  useAsyncClipboardAPI()
  return (
    <LinkContainer onClick={copy} onCopy={storeCopy}>
      <LinkText>Link to this version:</LinkText>
      <LinkInput
        copied={copied}
        id="share-link"
        disabled="disabled"
        defaultValue={url}
      />
      {copied && <Copied>Copied</Copied>}
    </LinkContainer>
  );
}
